import { useState } from 'react';

type UseCheckState = {
  selectedCheckboxIds: string[];
  setSelectedCheckboxIds: (ids: string[]) => void;
  resetSelectedCheckboxIds: () => void;
};
const useCheckState = (): UseCheckState => {
  const [selectedCheckboxIds, setSelectedCheckboxIds] = useState<string[]>([]);

  const resetSelectedCheckboxIds = (): void => {
    setSelectedCheckboxIds([]);
  };

  return {
    selectedCheckboxIds,
    setSelectedCheckboxIds,
    resetSelectedCheckboxIds,
  };
};

export default useCheckState;
